<div class="posterCard">
    <img [src]="show.poster" alt="">
    
    <div class="downloadButton" [ngClass]="{disabled: show.disabled || show.soon}" (click)="addToCalendar()" (mouseenter)="onOver($event)" (mouseleave)="onOut($event)" #btn>
        <div *ngIf="!show.disabled && !show.soon" class="pls">+</div>
        <div *ngIf="!show.disabled && !show.soon" class="downlText">CALENDAR</div>
        <div *ngIf="show.disabled || show.soon" class="downlText">{{show.soon || 'COMING SOON'}}</div>
    </div>
</div>